export default __webpack_public_path__ + "static/media/Rubik-Italic.dace38b0.ttf";